import React, { useState } from "react";
import AlertDialog from "../../../../components/alertDialog";
import i18n from "~/i18n";

export default function DeleteSourceDialog({
  sourceToDelete,
  isOpen,
  onSubmit,
  ...rest
}) {
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit() {
    setSubmitting(true);

    try {
      await onSubmit(sourceToDelete);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AlertDialog
      open={isOpen}
      title={i18n.t("chat:ai.sources.delete.header")}
      description={i18n.t("chat:ai.sources.delete.desc", { url: sourceToDelete?.url })}
      ctaText={i18n.t("chat:ai.sources.delete.confirm")}
      submitting={submitting}
      onCtaClick={handleSubmit}
      {...rest}
    />
  );
}
